import {
  amplitudeSendEvent,
  GTM_NOTSET_STRING,
  getScreenName,
  pushDataLayer,
} from '@musinsa/frontend-utils';
import { track } from '@musinsa/packages-event-snowplow';
import type { FC } from 'react';
import { paths29CM, pathsMusinsa, useNavigate, useUserInfo } from '../../../common';
import { SNOWPLOW_SCHEME } from '../../../snowplow';
import { ProductIcon } from '../EarningsBoostIcons';
import { EarningsBoostItem } from './EarningsBoostItem';

const LINK_ID = 'generate_product_link';
const LINK_TITLE = '개별 상품 링크 생성하기';
const LINK_TEXT = '추천하고 싶은 상품 링크 생성하고 공유해 보세요';

const LinkMusinsa: FC<{ className?: string }> = ({ className }) => {
  const { navigate } = useNavigate();
  const { data: userInfo } = useUserInfo();

  const handleClick = () => {
    if (!userInfo) return;

    amplitudeSendEvent({
      action_name: 'click',
      button_name: 'curating_try',
      component_name: 'button',
      event_name: 'click_button',
      from: getScreenName(),
      name: 'goods',
      section_name: 'mypage_dashboard',
    });
    pushDataLayer('click_button', {
      brand_id: GTM_NOTSET_STRING,
      button_id: 'curating_try',
      button_name: 'goods',
      index: GTM_NOTSET_STRING,
      section_index: '5',
      section_name: 'mypage_dashboard',
    });

    navigate(pathsMusinsa.search());
  };

  return (
    <EarningsBoostItem
      icon={<ProductIcon />}
      title={LINK_TITLE}
      text={LINK_TEXT}
      onClick={handleClick}
      className={className}
    />
  );
};

const Link29cm: FC<{ className?: string }> = ({ className }) => {
  const { navigate } = useNavigate();
  const handleClick = () => {
    navigate(paths29CM.search());

    track({
      schema: SNOWPLOW_SCHEME.CLICK_BUTTON,
      data: {
        page_name: 'curator_mypage',
        section_name: 'IncreaseMyRevenue',
        section_title: '나의 수익 올리기',
        position: 4,
        button_id: LINK_ID,
        button_name: LINK_TITLE,
      },
    });
  };
  return (
    <EarningsBoostItem
      icon={<ProductIcon />}
      title={LINK_TITLE}
      text={LINK_TEXT}
      onClick={handleClick}
      className={className}
    />
  );
};

export const GenerateProductLink = {
  LinkMusinsa,
  Link29cm,
};
